import React, {
  FC, memo, ReactNode, useEffect, useState,
} from 'react';
import classNames from 'classnames';
import useMediaQuery from '../../hooks/useMediaQuery';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import styles from './Modal.module.scss';
import { useModalsContext } from '../../contexts/ModalsContext';
import { FormType } from '../QuickQuoteForm/types';

interface ModalProps {
  title?: string;
  closeHandler: () => void;
  classes?: {
    overlay?: string;
    container?: string;
    title?: string;
  };
  isWithoutCloseButton?: boolean; // IO2702
  children?: ReactNode;
  isModalHidden?: boolean;
}

const Modal: FC<ModalProps> = ({
  title, closeHandler, children, classes, isWithoutCloseButton, isModalHidden,
}: ModalProps) => {
  const isMobile = useMediaQuery({ maxBreakpoint: 'xs' });

  const [isIO2684Active, setIsIO2684Active] = useState(false);

  const isCenterPage: boolean = !!document.querySelector('.space-right-buttons-outer');
  let optimizelyTitle = title;

  // hack in order to replace just some buttons on space profile page
  const { properties: modalsContextProperties, setMaxProgressReached } = useModalsContext();
  let isTableButton = false;
  if (isCenterPage) {
    isTableButton = modalsContextProperties.targetElement.href.includes('#nav-membership');
  }

  let isCheckAvailabilityButton = false;
  if (isCenterPage) {
    isCheckAvailabilityButton = modalsContextProperties.targetElement.classList.contains('checkAvailability');
  }

  // eslint-disable-next-line
  if (modalsContextProperties.formType === FormType.QuickQuote && !isTableButton) {
    optimizelyTitle = 'Quick quote';
  }

  // eslint-disable-next-line
  if (modalsContextProperties.formType === FormType.QuickQuote && isCheckAvailabilityButton) {
    optimizelyTitle = 'Check Availability';
  }

  useEffect(() => {
    const globalAny = global as any;
    setIsIO2684Active(globalAny?.instant?.optimizely?.io2684);
  }, []);

  return (
    <div className={classNames(styles.overlay, isModalHidden && styles.isHidden, classes?.overlay)}>
      <div className={classNames(styles.container, classes?.container)}>
        {!isWithoutCloseButton && (isIO2684Active && !isMobile) && (
          <button
            className={styles.floatingCloseButton}
            data-cy="modal-close-button"
            onClick={() => {
              closeHandler();

              setMaxProgressReached(0);
            }}
            type="button"
          >
            <CloseIcon className={styles.closeIcon} />
          </button>
        )}
        <div className={styles.overflownContainer}>
          <div className={classNames(styles.title, classes?.title)}>
            {optimizelyTitle}
            {!isWithoutCloseButton && (!isIO2684Active || isMobile) && (
              <button
                className={styles.closeButton}
                data-cy="modal-close-button"
                onClick={() => {
                  closeHandler();
    
                  setMaxProgressReached(0);
                }}
                type="button"
              >
                <CloseIcon className={styles.closeIcon} />
              </button>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
Modal.displayName = 'Modal';

export default memo(Modal);
